import { Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { serverFetch } from "../core/server";
import { clearUserSession } from "../store/user-slice";
import "./app-shell.css";

const AppShell = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const session = useSelector((state) => state.user.session);

  const onLogout = () => {
    serverFetch("auth/logout", { method: "POST" }).finally(() => {
      localStorage.removeItem("sessionId");
      dispatch(clearUserSession());
      navigate("/");
    });
  };

  return (
    <div className="app-shell">
      <header className="app-shell-header">
        <div className="app-shell-logo" onClick={() => navigate(session ? "/cabinet" : "/")}>
          <img src="/favicon.svg" alt="" width={24} height={24} />
          ВЕБ Окна
        </div>
        <nav className="app-shell-nav">
          <Button type={pathname === "/start" ? "primary" : "default"} onClick={() => navigate("/start")}>
            Как начать
          </Button>
          {session && (
            <>
              <Button
                type={pathname === "/cabinet" ? "primary" : "default"}
                onClick={() => navigate("/cabinet")}
              >
                Приложение
              </Button>
              {session.isSuperAdmin && (
                <>
                  <Button
                    type={pathname === "/cabinet/default" ? "primary" : "default"}
                    onClick={() => navigate("/cabinet/default")}
                  >
                    База по умолчанию
                  </Button>
                  <Button
                    type={pathname === "/cabinet/companies" ? "primary" : "default"}
                    onClick={() => navigate("/cabinet/companies")}
                  >
                    Компании
                  </Button>
                  <Button
                    type={pathname === "/cabinet/superadmins" ? "primary" : "default"}
                    onClick={() => navigate("/cabinet/superadmins")}
                  >
                    Суперадмины
                  </Button>
                </>
              )}
            </>
          )}
        </nav>
        <div className="app-shell-user">
          {session ? (
            <>
              <span className="app-shell-user-name">
                {session.userName}
                {session.companyName ? ` · ${session.companyName}` : ""}
              </span>
              <Button onClick={onLogout}>Выход</Button>
            </>
          ) : (
            <Button type="primary" onClick={() => navigate("/auth")}>
              Войти
            </Button>
          )}
        </div>
      </header>
      <main className="app-shell-content">{children}</main>
    </div>
  );
};

export default AppShell;
